// extracted by mini-css-extract-plugin
export default {"overlay":"Pu-z","bodyOpen":"Qu-z","content":"Ru-z","header":"Su-z","close":"Tu-z","closeNoHeading":"Uu-z"};